export default {
  SET_PROMO_CATEGORIES (state, promo_categories) {
    state.promo_categories = promo_categories
  },
  REMOVE_RECORD (state, itemId) {
    const promoCategoryIndex = state.promo_categories.findIndex((u) => u.id === itemId)
    state.promo_categories.splice(promoCategoryIndex, 1)
  }
}
